import { render } from "./Configuraciones.vue?vue&type=template&id=2008a5f9"
import script from "./Configuraciones.vue?vue&type=script&lang=js"
export * from "./Configuraciones.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__